import React, { useState, useEffect } from 'react';
import { servicesAPI } from '../../services/api';
import './ServiceSelector.scss';

const ServiceSelector = ({ onServiceSelect, selectedService, selectedLocation }) => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchServices();
  }, [selectedLocation]);

  const fetchServices = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await servicesAPI.getAll();
      // Filter only booking services
      let bookingServices = (response.data || []).filter(
        (service) => service.isBookingService !== false
      );
      // Filter by selected location if available
      if (selectedLocation) {
        bookingServices = bookingServices.filter((service) => {
          if (!service.locations || service.locations.length === 0) return true;
          return service.locations.some(
            (loc) => (loc._id || loc) === selectedLocation._id
          );
        });
      }
      setServices(bookingServices);
    } catch (err) {
      setError('Failed to load services');
      console.error('Error fetching services:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleServiceClick = (service) => {
    onServiceSelect(service);
  };

  const formatDuration = (minutes) => {
    if (minutes < 60) {
      return `${minutes} min`;
    }
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
  };

  if (loading) {
    return (
      <div className="service-selector">
        <div className="loading-state">Loading services...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="service-selector">
        <div className="error-state">{error}</div>
      </div>
    );
  }

  return (
    <div className="service-selector">
      <h2>Select a Service</h2>
      <p className="subtitle">Choose the type of appointment you need</p>
      
      <div className="services-grid">
        {services.map((service) => (
          <div
            key={service._id}
            className={`service-card ${selectedService?._id === service._id ? 'selected' : ''}`}
            onClick={() => handleServiceClick(service)}
          >
            {service.image && (
              <div className="service-image">
                <img src={service.image} alt={service.title} />
              </div>
            )}
            <div className="service-content">
              <div className="service-header">
                <h3>{service.title}</h3>
                <span className="duration-badge">
                  {formatDuration(service.duration || 30)}
                </span>
              </div>
              {service.serviceType && service.serviceType !== 'Other' && (
                <span className="service-type">{service.serviceType}</span>
              )}
              {service.description && (
                <p className="service-description">{service.description}</p>
              )}
            </div>
            <div className="service-footer">
              <span className="select-indicator">
                {selectedService?._id === service._id ? '✓ Selected' : 'Select'}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceSelector;
